import React from 'react';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon';

export default createSvgIcon(
  <path d="M13 2C15.7614 2 18 4.23858 18 7C18 7.55228 17.5523 8 17 8C16.4872 8 16.0645 7.61396 16.0067 7.11662L16 7C16 5.34315 14.6569 4 13 4C11.4023 4 10.0963 5.24892 10.0051 6.82373L10 7V13H13C13.5128 13 13.9355 13.386 13.9933 13.8834L14 14C14 14.5128 13.614 14.9355 13.1166 14.9933L13 15H10V20H18C18.5523 20 19 20.4477 19 21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21C5 20.4477 5.44772 20 6 20H8V15H7C6.48716 15 6.06449 14.614 6.00673 14.1166L6 14C6 13.4872 6.38604 13.0645 6.88338 13.0067L7 13H8V7C8 4.23858 10.2386 2 13 2Z" />,
  'Pound'
);
